import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=c1b0d908&"
import script from "./Test.vue?vue&type=script&lang=js&"
export * from "./Test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b0d908')) {
      api.createRecord('c1b0d908', component.options)
    } else {
      api.reload('c1b0d908', component.options)
    }
    module.hot.accept("./Test.vue?vue&type=template&id=c1b0d908&", function () {
      api.rerender('c1b0d908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zch/Test.vue"
export default component.exports